function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import { GRID_CARD_CLICKED, GRID_CARD_HOVERED } from "/constants/bigbrain-event-types";
import GridImage from "segments/desktop/core-components/grid-image/grid-image";
import Title from "segments/desktop/core-components/title/title";
import Paragraph from "segments/desktop/core-components/paragraph/paragraph";
import SecondaryButton from "segments/desktop/core-components/button/secondary-button/secondary-button";
import classnames from "classnames";
import { StyledGridImageWithParagraph } from "./grid-image-with-paragraph.scss";
import DefaultProps from "./default-props";
class GridImageWithParagraph extends PureComponent {
    renderComponent() {
        const _this_props = this.props, { fullParagraph, titleSize, textSize } = _this_props, restImageProps = _object_without_properties(_this_props, [
            "fullParagraph",
            "titleSize",
            "textSize"
        ]);
        return /*#__PURE__*/ _jsxs("div", {
            className: "grid-image-with-paragraph",
            children: [
                (restImageProps === null || restImageProps === void 0 ? void 0 : restImageProps.src) && /*#__PURE__*/ _jsx("div", {
                    className: "grid-image-wrapper",
                    children: /*#__PURE__*/ _jsx(GridImage, _object_spread({}, restImageProps))
                }),
                this.renderParagraph()
            ]
        });
    }
    render() {
        const { fullParagraph } = this.props;
        const { buttonConfig } = fullParagraph;
        const { url, isOpenLinkInNewTab } = buttonConfig || {};
        return /*#__PURE__*/ _jsx(StyledGridImageWithParagraph, {
            className: classnames("card-grid-link", {
                "without-link": !url
            }),
            href: url,
            onClick: this.handleClick,
            onMouseEnter: this.handleHover,
            target: isOpenLinkInNewTab ? "_blank" : "_self",
            children: this.renderComponent()
        });
    }
    constructor(...args){
        super(...args);
        _define_property(this, "handleClick", ()=>{
            const { fullParagraph } = this.props;
            const { buttonConfig, title } = fullParagraph;
            const { url, buttonText } = buttonConfig || {};
            BigBrain("track", GRID_CARD_CLICKED, {
                kind: buttonText,
                info1: title,
                info2: url
            });
        });
        _define_property(this, "handleHover", ()=>{
            const { fullParagraph } = this.props;
            const { buttonConfig, title } = fullParagraph;
            const { url, buttonText } = buttonConfig || {};
            BigBrain("track", GRID_CARD_HOVERED, {
                kind: buttonText,
                info1: title,
                info2: url
            });
        });
        _define_property(this, "renderParagraph", ()=>{
            const { fullParagraph, titleSize, textSize, width, hideButton } = this.props;
            const { title, body, buttonConfig } = fullParagraph;
            return /*#__PURE__*/ _jsxs("div", {
                className: "grid-paragraph-wrapper",
                style: {
                    width
                },
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "title-wrapper",
                        children: /*#__PURE__*/ _jsx(Title, {
                            title: title,
                            titleSize: titleSize
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "paragraph-body-wrapper",
                        children: /*#__PURE__*/ _jsx(Paragraph, {
                            body: body,
                            textSize: textSize
                        })
                    }),
                    !hideButton && /*#__PURE__*/ _jsx("div", {
                        className: "button-wrapper",
                        children: /*#__PURE__*/ _jsx(SecondaryButton, _object_spread({}, buttonConfig))
                    })
                ]
            });
        });
    }
}
export { GridImageWithParagraph as default };
GridImageWithParagraph.defaultProps = DefaultProps;
